import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";

const MoveItemModal = ({ open, onClose, onSubmit, item, tables = [] }) => {
  const [quantity, setQuantity] = useState(item?.quantity || 1);
  const [targetTable, setTargetTable] = useState("");

  const handleSubmit = () => {
    if (!targetTable) return alert("يرجى اختيار طاولة مستهدفة");
  onSubmit({
  item_id: Number(item.id),           // ✅ لازم رقم
  source_order_id: Number(item.order_id),
  quantity: Number(quantity),
  target_table: Number(targetTable),
});

  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>نقل الصنف: {item?.product_name}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="الكمية"
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
        />
        <FormControl fullWidth>
          <InputLabel>اختر الطاولة</InputLabel>
          <Select
            value={targetTable}
            label="اختر الطاولة"
            onChange={(e) => setTargetTable(e.target.value)}
          >
            {tables.map((table) => (
              <MenuItem key={table.id} value={table.id}>
                {`طاولة ${table.name}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>إلغاء</Button>
        <Button onClick={handleSubmit} variant="contained">
          نقل
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveItemModal;
